module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"guest_mode_warning_3":"Понятно"},"en":{"guest_mode_warning_3":"OK"}}')
  delete Component.options._Ctor
}
